<div *ngIf="spinner" class="avla_spinner">
  <div class="avla_spinner__content">
    <img src="./assets/gif/spinner-avla.gif">
  </div>
</div>